const localization = {
  en: {
    value: 'Value',
    normalRange: 'Normal Range',
    date: 'Date',
    findTrendLine: 'Show Trend line',
    somethingWentWrong: 'Something went wrong'
  },
  es: {
    value: 'Valor',
    normalRange: 'Rango normal',
    date: 'Fecha',
    findTrendLine: 'Mostrar línea de tendencia',
    somethingWentWrong: 'Ha ocurrido un error'
  },
  keyMapping: {
    value: 'UFD_Value_Text',
    normalRange: 'UFD_Normal_Range_Text',
    date: 'UFD_Date_Text',
    findTrendLine: 'UFD_Trend_Line_Label',
    somethingWentWrong: 'UFD_Error_Text'
  }
}

export default localization
